<template>
  <div class="login-view" />
</template>

<script>
export default {
  name: 'notfound-view',

  mounted () {
    this.$router.push('/')
  }
}
</script>
